import type { FunctionComponent } from 'react';

import { LazyTrelloRenderer } from '@trello/editor/renderer';
import { RouterLink } from '@trello/router/router-link';

import type { CheckItemEntity } from './types';

import styles from './CheckItem.less';

interface CheckItemProps extends Pick<CheckItemEntity, 'id' | 'text'> {
  actionUrl?: string;
  onClick?: () => void;
}

export const CheckItem: FunctionComponent<CheckItemProps> = ({
  text,
  actionUrl,
  onClick,
}) => {
  return (
    <RouterLink
      href={actionUrl}
      onClick={onClick}
      className={styles.currentCheckItem}
    >
      <LazyTrelloRenderer text={text} contentType="checkitem" />
    </RouterLink>
  );
};
